<template>
  <div>
    <div class="banner">
      <img class="banner" src="@/assets/banner.png">
    </div>
    <div>
      <img class="subtext" src="@/assets/subtext.png">
    </div>
    <br>
    <p>decades of experience</p>
    <p>building beautiful automations</p>
    <p>for the biggest names in technology</p>
    <br>
    <br>
    <button
      class="button is-static is-outlined is-info is-rounded"
      v-animate-css="'fadeIn'"
      :key="displayText"
    >{{ displayText }}</button>
    <br>
    <br>
    <br>
    <a href="mailto: info@bimross.com">info@bimross.com</a>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      services: [
        "Integration Services",
        "Web Applications",
        "Process Improvements",
        "Revit Automations",
        "User Experience",
        "Architectural Design"
      ],
      displayText: "Revit Automations",
      delay: 2500
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.setInterval(() => {
        this.getService();
      }, this.delay);
    });
  },
  methods: {
    getService() {
      this.displayText = this.services[
        Math.floor(Math.random() * this.services.length)
      ];
      return;
    }
  }
};
</script>

<style lang="scss" scoped>
div.banner {
  margin-top: 150px;
}
img.banner {
  height: 70px;
}
img.subtext {
  height: 38px;
  margin-top: -6px;
}
button {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 2.5s;
  animation-duration: 2.5s;
}
p {
  color: #606060;
}
</style>

